import { RQ } from 'utils';
import * as wx from 'utils/wx';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getTipInfo: async function () {
    if (G.member && G.member.token) {
      const res = await RQ.mall.get('/api/h5/user/member/tips', {}, { skipAuth: true });
      if (res && res.code == 0) {
        this.tipInfo = res.data;
        this.tipDetail = res.data.tipMsg != undefined ? res.data.tipMsg.replace(/\n/g, '<br/>') : '';
        this.renewPopup = res.data.openType == 1 ? false : true;
      } else {
        this.tips(res.msg, 1500);
      }
    }

  },
  getMemberSet: async function (giveUpFlag) {
    // orderId: this.params.orderId
    // const res = await RQ.mall.get('/api/h5/member/getMemberSet');
    // const res = await RQ.mall.get('/api/app/user/getMemberShipPrice');
    const res = await RQ.mall.get('/api/h5/user/getMemberShipPrice', {
      giveUpFlag: giveUpFlag
    });
    if (res && res.code == 0) {
      if (giveUpFlag != undefined) {
        this.renewPopup = false;
      }
      const data = res.data;
      const isSingle = data.usableMoney != undefined && data.usableMoney != 0 && data.combinationPay == 0;
      const isCombination = data.usableMoney != undefined && data.usableMoney !== 0;
      this.data = {
        payRes: res,
        payInfo: data,
        balancePayway: isCombination,
        isCombination: isCombination,
        isSingle: isSingle,
        payway: isSingle ? undefined : 'wechat',
        ...res.data
      };
    } else {
      this.tips(res.msg);
    }
  },
  openPay: function () {
    this.popupVisible1 = true;
  },
  cancel: function () {
    let self = this;
    self.popupVisible1 = false;
  },
  continueFn: function () {
    console.log('继续=======');
    this.renewPopup = false;
  },
  selectBalancePayway: function () {
    if (this.data.usableMoney !== 0) {
      this.data.balancePayway = !this.data.balancePayway;
      this.data.payway = this.data.isSingle ? undefined : this.data.payway;
    }
  },
  selectPayWay: function (payway) {
    const { isSingle, isCombination } = this.data;
    console.log('selectPayWay', payway, isSingle, isCombination);
    if (isSingle) {
      this.data.balancePayway = false;
      this.data.payway = payway ? (isCombination ? payway : undefined) : payway;
    } else {
      this.data.payway = this.data.payway == payway ? (isCombination ? payway : undefined) : payway;
    }
  },
  pay: async function () {
    if (this.data.balancePayway == false && this.data.payway == undefined) {
      this.tips('请选择支付方式');
      return;
    }
    var giveUpFlag;
    console.log('payInfo=====', this.data.payInfo);
    if (this.data.payInfo.openType == 1) { //1：开通，2：续费
      giveUpFlag = 1;
    } else {
      giveUpFlag = 0;
    }
    const resOrder = await RQ.mall.post('/api/app/order/saveOrder', {
      productId: '2',
      giveUpFlag: giveUpFlag,
      isPlatform: G.is_platform !== undefined ? G.is_platform : 0
    }, { jsonBody: true });
    console.log(resOrder);
    if (resOrder && resOrder.code == 0) {
      const res = await RQ.mall.post('/api/h5/order/saveOrderPayInfo', {
        orderId: resOrder.data.orderId,
        payWay: this.data.payway,
        usableAccountPay: this.data.balancePayway ? 1 : 0,
        usableReserveMoneyPay: 0,
        clientType: 2, // 1：app，2：h5，3：小程序
        isPlatform: G.is_platform !== undefined ? G.is_platform : 0
      }, { jsonBody: true });

      if (res && res.code == 0) {
        wx.pay(this.$route, res.data, () => {
          // 支付成功
          this.$router.replace({
            path: `/${G.enterprise}/vip/paySuccess`
          });
        }, () => {
          // 支付失败
          RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: resOrder.data.orderId });
        }, () => {
          // 支付取消
          RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: resOrder.data.orderId });
        });
      } else {
        this.tips(res.msg || '获取支付参数失败');
      }
    } else {
      this.tips(resOrder.msg);
    }
  }

  /**
   * selectBalancePayway: function() {
    this.data.balancePayway = !this.data.balancePayway;
    this.data.payway = this.data.isSingle ? undefined : this.data.payway
  },
   selectPayWay: function (payway) {
    const { isSingle, isCombination } = this.data;
    console.log('selectPayWay', payway, isSingle, isCombination)
    if (isSingle) {
      this.data.balancePayway = false;
      this.data.payway = payway ? (isCombination ? payway : undefined) : payway
    } else {
      this.data.payway = this.data.payway == payway ? (isCombination ? payway : undefined) : payway
    }
  },
   pay1: async function () {
    const resOrder = await RQ.mall.post('/api/app/order/saveOrder', {productId: '2'}, {jsonBody: true})
    if (resOrder && resOrder.code == 0) {
      const res = await RQ.mall.post('/api/h5/order/saveOrderPayInfo', {
        orderId: resOrder.data.orderId,
        payWay: this.data.payway,
        usableAccountPay: this.data.balancePayway ? 1 : 0
      }, {jsonBody: true})

      if (res && res.code == 0) {
        wx.pay(res.data, () => {
          // 支付成功
          this.$router.replace({ path: `/${G.enterprise}/vip/paySuccess` });
        }, () => {
          // 支付失败
          RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: resOrder.orderId })
        }, () => {
          // 支付取消
          RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: resOrder.orderId })
        })
      } else {
        this.tips(res.msg || '获取支付参数失败')
      }
    } else {
      this.tips(resOrder.msg)
    }
  }
   */
};



// WEBPACK FOOTER //
// ./src/module/vip/pay/action.js